var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvBayMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 61.985,
    height: 69.734,
    viewBox: "0 0 61.985 69.734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#64b22f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85e841"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4772",
    "data-name": "Group 4772",
    transform: "translate(-0.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3705",
    "data-name": "Path 3705",
    d: "M0,20.5,30.993,5,61.986,20.5V59.238l-30.993,15.5L0,59.238Z",
    transform: "translate(0.07 -5)",
    fill: "#253137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_13",
    "data-name": "Subtraction 13",
    d: "M14249.193,19467.895h0l-27.894-13.947,27.894-13.947,27.894,13.947Zm2.723-14.855a.454.454,0,0,1,0,.908,14.461,14.461,0,0,0-4.606.709,11.427,11.427,0,0,0-3.23,1.684,10.283,10.283,0,0,0-2.019,1.99,7.374,7.374,0,0,0-.971,1.633.909.909,0,0,0,1.683.689,7.457,7.457,0,0,1,2.039-2.57,5.566,5.566,0,0,0,1.746,1.535,5.322,5.322,0,0,0,2.618.688,5.59,5.59,0,0,0,.6-.033,7.563,7.563,0,0,0,3.064-.887,8.007,8.007,0,0,0,2.4-2,9.248,9.248,0,0,0,1.564-2.861,10.754,10.754,0,0,0,.339-5.592,9.58,9.58,0,0,0-.625-1.969.449.449,0,0,0-.406-.275.461.461,0,0,0-.4.242,4.865,4.865,0,0,1-4.253,2.482h-2.269a5.443,5.443,0,0,0-5.448,5.447,4.779,4.779,0,0,0,.035.5v0l0,.035c0,.014,0,.027,0,.043a12.263,12.263,0,0,1,3.354-1.686,14.106,14.106,0,0,1,2.2-.52A16.756,16.756,0,0,1,14251.916,19453.039Z",
    transform: "translate(-14218.201 -19401.258)",
    fill: "url(#linear-gradient4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Kerb_White",
    "data-name": "Kerb White",
    transform: "translate(-0.13 -2.79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5470",
    "data-name": "Path 5470",
    d: "M444.15,111.86h2.13v3.907a.208.208,0,0,0,.042-.032,2.612,2.612,0,0,1,1.628-1.045,3.039,3.039,0,0,1,3.464,1.548,4.449,4.449,0,0,1,.5,1.592,6.487,6.487,0,0,1,.024,1.509,4.376,4.376,0,0,1-.728,2.127,2.994,2.994,0,0,1-1.828,1.252,3.863,3.863,0,0,1-2.2-.228,2.11,2.11,0,0,1-.963-.861c-.009-.016-.021-.03-.032-.046l-.015.006v.981h-2.027Q444.15,117.218,444.15,111.86Zm5.682,6.833c0-.048,0-.1,0-.143a3.521,3.521,0,0,0-.23-1.2,1.889,1.889,0,0,0-.575-.811,1.615,1.615,0,0,0-1.255-.317,1.517,1.517,0,0,0-1.052.619,2.306,2.306,0,0,0-.37.766,4.024,4.024,0,0,0-.121,1.541,3.011,3.011,0,0,0,.334,1.143,1.64,1.64,0,0,0,2.2.714,1.724,1.724,0,0,0,.8-.886A3.472,3.472,0,0,0,449.832,118.693Z",
    transform: "translate(-406.579 -90.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5471",
    "data-name": "Path 5471",
    d: "M171.32,168.664h-5.611c.012.122.02.237.034.352a2.369,2.369,0,0,0,.216.759,1.417,1.417,0,0,0,.882.762,2.267,2.267,0,0,0,1.647-.078,1.6,1.6,0,0,0,.675-.539,1.4,1.4,0,0,0,.124-.237c.015-.034.028-.047.066-.047h1.789l.045,0c-.014.044-.027.085-.041.125a4.048,4.048,0,0,1-.846,1.452,3.142,3.142,0,0,1-1.429.869,4.8,4.8,0,0,1-1.646.167,4.118,4.118,0,0,1-1.476-.346,3.521,3.521,0,0,1-1.919-2.1,4.8,4.8,0,0,1-.268-1.731,4.317,4.317,0,0,1,.45-1.911,3.692,3.692,0,0,1,2.744-2.054,4.023,4.023,0,0,1,2.214.182,3.417,3.417,0,0,1,1.826,1.653,4.483,4.483,0,0,1,.511,1.788c.022.292.011.587.016.88A.4.4,0,0,1,171.32,168.664Zm-2.135-1.35a2.827,2.827,0,0,0-.348-.992,1.322,1.322,0,0,0-.832-.6,2.132,2.132,0,0,0-.589-.058,1.848,1.848,0,0,0-.891.231,1.618,1.618,0,0,0-.757,1.07c-.028.114-.042.232-.063.354Z",
    transform: "translate(-140.626 -139.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5472",
    "data-name": "Path 5472",
    d: "M195.527,22.409l-.541-.565-1.04-1.089q-.773-.809-1.545-1.619a.122.122,0,0,1-.03-.077q0-1.273,0-2.546c0-.012,0-.023,0-.049l3.157,3.318,5.547-3.323v.072q0,1.254,0,2.508a.093.093,0,0,1-.053.093q-2.729,1.626-5.457,3.255Z",
    transform: "translate(-167.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5473",
    "data-name": "Path 5473",
    d: "M17.329,122.583H15.2V111.87h2.129Z",
    transform: "translate(0 -90.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5474",
    "data-name": "Path 5474",
    d: "M334.451,172.308H332.32v-7.761h2.022v1.428l.016.006a.421.421,0,0,0,.032-.05,2.7,2.7,0,0,1,1.781-1.508,2.141,2.141,0,0,1,.922-.07c.217.034.217.034.217.251v1.78c-.177-.021-.349-.046-.523-.06a2.594,2.594,0,0,0-1.056.111,1.707,1.707,0,0,0-1.073,1.069,3.181,3.181,0,0,0-.2,1.132c-.005,1.194,0,2.389-.006,3.583Z",
    transform: "translate(-300.582 -140.159)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5475",
    "data-name": "Path 5475",
    d: "M58.77,171.506l.408-.39,1.341-1.283q.594-.569,1.189-1.136a.131.131,0,0,1,.08-.036q1.144,0,2.289,0l.042,0-2.975,2.846,2.974,4.993-.066,0H61.8a.081.081,0,0,1-.081-.042q-1.471-2.473-2.943-4.943A.094.094,0,0,0,58.77,171.506Z",
    transform: "translate(-41.298 -144.261)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5476",
    "data-name": "Path 5476",
    d: "M595.4,110.73a.784.784,0,0,1,.795.664.773.773,0,0,1-.632.89.8.8,0,0,1-.888-.418.776.776,0,0,1,.576-1.119C595.3,110.737,595.352,110.735,595.4,110.73Zm-.008,1.4a.619.619,0,0,0,.016-1.237.619.619,0,0,0-.016,1.237Z",
    transform: "translate(-549.179 -89.354)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5477",
    "data-name": "Path 5477",
    d: "M604.585,117.763l.23.382c-.06,0-.109,0-.159,0a.073.073,0,0,1-.045-.033c-.053-.089-.109-.178-.154-.271a.105.105,0,0,0-.144-.062v.363h-.174v-.87c.073,0,.147,0,.221,0a1.777,1.777,0,0,1,.236.012.219.219,0,0,1,.214.239c0,.131-.058.2-.2.235Zm-.27-.36v.234c.08-.005.156-.009.232-.016a.1.1,0,0,0,0-.2C604.473,117.411,604.4,117.408,604.315,117.4Z",
    transform: "translate(-558.226 -95.552)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvBayMarker);
export default __webpack_public_path__ + "static/media/EVBayMarker.e0dd7125c90f35b04804799a791121a3.svg";
export { ForwardRef as ReactComponent };